const moduleName = 'tooltip';

export function tooltip() {
    document.querySelectorAll('.js-has-tooltip').forEach((el) => {
        el.addEventListener('mouseenter', function (e){
            const tooltip = document.createElement('span');
            const tooltipInner = document.createElement('span');
            tooltip.appendChild(tooltipInner);
            tooltip.classList.add('tooltip','js-tooltip');
            tooltip.querySelector('span').innerHTML = el.dataset.tooltip;
            el.appendChild(tooltip);
            tooltip.classList.add('_visible');
            if(tooltip.getBoundingClientRect().x + tooltip.offsetWidth > document.body.offsetWidth) {
                tooltip.style.left = 'auto';
                tooltip.style.right = '0';
            }
        });
        el.addEventListener('mouseleave', function (){
            const tooltip = this.querySelector('.js-tooltip');
            if(tooltip){
                tooltip.classList.add('_hidden');
                setTimeout(function () {
                    tooltip.classList.remove('_visible');
                    tooltip.remove();
                }, 300);
            }
        });
    });
}
